// extracted by mini-css-extract-plugin
module.exports = {"tip-btn":"tip-btn_tip-btn__pbccv","action-btn":"tip-btn_action-btn__r1udP","active":"tip-btn_active__uy5yr"};